module.exports = __webpack_public_path__ + "static/partner-2bc833602db25796d753df225daf5acf.png";